<template>
  <div id="app">
    <div class="menu-box" v-if="screenWidth > 750">
      <div class="log-box">
        <p>বিজ্ঞতা ঋণ</p>
      </div>
      <div class="menu-item">
        <div @click="choiceMenu(1)" :class="(menuIndex === 1) ? 'choice' : ''">হোমপেজ</div>
        <div @click="choiceMenu(2)" :class="(menuIndex === 2) ? 'choice' : ''">পদক্ষেপ</div>
        <div @click="choiceMenu(3)" :class="(menuIndex === 3) ? 'choice' : ''">আমাদের সুবিধা</div>
        <div @click="choiceMenu(4)" :class="(menuIndex === 4) ? 'choice' : ''">যোগাযোগ করুন</div>
      </div>
    </div>
    <div id='step_1' ref="step_1"></div>
    <div class="banner-box">
      <img src="../assets/banner.png" class="banner">
      <div class="app-name">
        <div class="title">বিজ্ঞতা ঋণ-সুবিধাজনক নিরাপদ</div>
        <div class="content">
          একটি সুবিধাজনক নিরাপদ এবং স্থিতিশীল প্ল্যাটফর্ম
        </div>
      </div>
    </div>

    <div id='step_2' ref="step_2"></div>
    <div class="list-box">
      <img src="../assets/list-1.png" class="list">
      <div class="list-text">
        <div class="title">ঋণ কীভাবে আবেদন করবেন?</div>
        <div class="item">
          <img src="../assets/fanggou.png" alt="">
          <p>একটি অ্যাকাউন্ট নিবন্ধন করুন।</p>
        </div>
        <div class="item">
          <img src="../assets/fanggou.png" alt="">
          <p>যোগ্যতা পরীক্ষা করার জন্য মৌলিক তথ্য পূরণ করুন।</p>
        </div>
        <div class="item">
          <img src="../assets/fanggou.png" alt="">
          <p>ইলেকট্রনিক ভাবে চুক্তি স্বাক্ষর করার জন্য সম্মতি দিন।</p>
        </div>
        <div class="item">
          <img src="../assets/fanggou.png" alt="">
          <p>প্রাধিকৃত হওয়ার পরে, ধন আপনার অ্যাকাউন্টে স্থানান্তর করা হবে।</p>
        </div>
      </div>
    </div>

    <div id='step_3' ref="step_3"></div>
    <div class="text-box">
      <div class="title">আমাদের সুবিধা</div>
      <img src="../assets/subtitle.png" class="subtitle">
      <div class="text-list-box">
        <div class="item-text-box">
          <p>বিস্তারিত বর্ণনা：</p>
          <div>বিজ্ঞতা ঋণ হলো একটি ঋণ এবং ক্রেডিট প্ল্যাটফর্ম, যা বাংলাদেশের বিভিন্ন অঞ্চলের পেশাদার ব্যক্তিদের জন্য দ্রুত ব্যক্তিগত ঋণ আবেদন এবং ক্রেডিট প্রদান করে। এই প্ল্যাটফর্মে ব্যবহারকারীদের পূর্ণাঙ্গ ক্রেডিট রেটিং এবং উন্নত ক্রেডিট সেবা প্রদান করার জন্য বিভিন্ন ঋণ প্রোডাক্ট উপলব্ধ করানো হয়। ঋণ আবেদনের প্রক্রিয়া অত্যন্ত সহজ এবং পূর্ণাঙ্গ করার জন্য প্রয়োজনীয় তথ্য যেমন পরিচয়পত্রের তথ্য এবং ব্যক্তিগত ছবি প্রদান করতে হবে।</div>
        </div>
        <img src="../assets/list-2.png" alt="">
      </div>
    </div>

    <div id='step_4' ref="step_4"></div>
    <div class="list-box">
      <img src="../assets/list-3.png" class="list">
      <div class="list-text">
        <div class="title">উপকারিতা：</div>
        <div class="item">
          <img src="../assets/fanggou.png" alt="">
          <p>কম মুদ্রা</p>
        </div>
        <div class="item">
          <img src="../assets/fanggou.png" alt="">
          <p>স্থিতিশীল মুদ্রা</p>
        </div>
        <div class="item">
          <img src="../assets/fanggou.png" alt="">
          <p>দ্রুত, নিরাপদ এবং ভরপূর্ণ ঋণ অনুমোদন</p>
        </div>
        <div class="item">
          <img src="../assets/fanggou.png" alt="">
          <p>পরিষ্ক্রিয়া শোধ, লেনদেন সুবিধাজনক</p>
        </div>
        <div class="item">
          <img src="../assets/fanggou.png" alt="">
          <p>সহজ প্রক্রিয়া</p>
        </div>
      </div>
    </div>

    <div id='step_5' ref="step_5"></div>
    <div class="text-box">
      <div class="text-list-box">
        <div class="item-text-box">
          <p>ব্যক্তিগত তথ্য সুরক্ষা এবং স্টোরেজ：</p>
          <div>পার্সোনাল সিকিউরিটি ম্যানেজমেন্ট: আমরা কর্মচারী বা আউটসোর্সড কর্মীদের উপর কঠোর ব্যবস্থাপনাও গ্রহণ করেছি যাদের আপনার তথ্যের অ্যাক্সেস থাকতে পারে, যার মধ্যে রয়েছে কিন্তু সীমাবদ্ধ নয় বিভিন্ন অবস্থান অনুযায়ী বিভিন্ন কর্তৃপক্ষের নিয়ন্ত্রণ গ্রহণ, তাদের সাথে গোপনীয়তা চুক্তি স্বাক্ষর করা এবং তাদের ক্রিয়াকলাপ পর্যবেক্ষণ করা। আমরা আপনার তথ্য সুরক্ষিত করতে এবং যুক্তিসঙ্গত নিরাপত্তা সুরক্ষা প্রদান করতে বিদ্যমান প্রযুক্তি অনুযায়ী সংশ্লিষ্ট নিরাপত্তা ব্যবস্থা প্রদান করব। আমরা আপনার তথ্য ফাঁস, ক্ষতিগ্রস্ত বা হারিয়ে যাওয়া প্রতিরোধ করার জন্য যথাসাধ্য চেষ্টা করব। ব্যক্তিগত তথ্য সুরক্ষার গুরুত্ব সম্পর্কে কর্মীদের সচেতনতা বাড়াতে আমরা নিরাপত্তা এবং গোপনীয়তা সুরক্ষা প্রশিক্ষণ কোর্সের আয়োজন করব।</div>
        </div>
        <img src="../assets/list-4.png" alt="">
      </div>
    </div>

    <div id='step_6' ref="step_6"></div>
    <div class="del-data-box">
      <div class="tel-box" v-if="steps == 1">
        <div class="tip"> আপনার ডেটার নিরাপত্তা নিশ্চিত করতে ডেটা মুছে ফেলার ফাংশন ব্যবহার করা। আপনাকে অবশ্যই আপনার পরিচয় যাচাই করতে হবে</div>
        <div class="title">অনুগ্রহ করে আপনার মোবাইল ফোন নম্বর লিখুন</div>
        <input v-model="mobile" type="text" class="tel-in" placeholder="অনুগ্রহ করে আপনার ফোন নম্বর লিখুন">
        <input v-model="password" type="password" class="tel-pa" placeholder="অনুগ্রহ করে অ্যাপটির জন্য আপনার পাসওয়ার্ড লিখুন">
        <div class="btn" @click="delSearch">পরবর্তী পদক্ষেপ</div>
      </div>
      <div class="tel-box" v-else-if="steps == 2">
        <div class="กล่องข้อความ">
          প্রিয় ব্যবহারকারী
          <br> হ্যালো! সহজেই অ্যাপটি ব্যবহার করার জন্য আপনাকে অনেক ধন্যবাদ।
          <br> আপনার অ্যাকাউন্ট মুছে ফেলার জন্য আবেদন করার আগে আপনার সমস্ত আদেশের জন্য অর্থ প্রদান করা হয়েছে তা নিশ্চিত করুন. এবং বর্তমানে পর্যালোচনার অধীনে কোন আদেশ নেই। দয়া করে মনে রাখবেন যে একবার আপনার অ্যাকাউন্ট মুছে ফেলা হয়, ডেটা পুনরুদ্ধার করা সম্ভব হবে না। ব্যবহারের আগে সাবধানে নিশ্চিত করুন. এই অ্যাপটি ব্যক্তিগত সম্পত্তির কোনো ক্ষতির জন্য দায়ী নয়।
          <br> যদি আপনি নিশ্চিত করেন যে আপনি আপনার ডেটা মুছে দিতে চান। অনুগ্রহ করে নিচের বোতামটি ক্লিক করুন
        </div>
        <div class="btn" @click="candelete">মোছা নিশ্চিত করুন</div>
      </div>

      <div class="tel-box" v-else-if="steps == 3">
        <div class="title">আপনার পরিচয় যাচাই করতে অনুগ্রহ করে যাচাইকরণ কোড লিখুন।</div>
        <div class="iump-box">
          <input v-model="code" type="text" class="car-in tel-in" placeholder="অনুগ্রহ করে 4 সংখ্যার যাচাইকরণ কোড লিখুন" />
          <div class="count-btn" @click="Reenviar"> {{ Time > 0 ? Time : 'আবার পাঠান' }} </div>
        </div>
        <div class="btn" @click="doDelete">ঠিক আছে</div>
      </div>

      <div class="tel-box del-box" v-else-if="steps == 4">
        <img src="../assets/del.png" alt="">
        <p>আপনার ডেটা মুছে ফেলা হয়েছে!</p>
      </div>
      <div class="tel-box" v-else-if="steps == 5">
        <div class="title">আইডেন্টিফিকেশন কার্ড ভেরিফিকেশন</div>
        <input v-model="idcard" type="text" class="tel-in" placeholder="পরিদর্শন">
        <div class="btn" @click="verifyIdCard">পরিদর্শন</div>
      </div>
    </div>

    <div class="foot-box">
      <div class="foot-text-box">
        <p>যোগাযোগ করুন</p>
        <div>বিজ্ঞতা ঋণ</div>
      </div>
      <div class="foot-list">
        <img src="../assets/lin.png" alt="">
        <p>কাজের সময়: সোমবার থেকে রবিবার, সকাল ৯:০০ থেকে রাত ৬:০০</p>
      </div>
      <div class="foot-list">
        <img src="../assets/mail.png" alt="">
        <p>কাস্টমার সার্ভিস ইমেল: seasonalveget@gmail.com</p>
      </div>
      <div class="foot-list">
        <img src="../assets/address.png" alt="">
        <p>ঠিকানা: 411 Bir Uttam Mir Shawkat Sarak, Dhaka 1208</p>
      </div>
    </div>
    <div class="copyright">Copyright© বিজ্ঞতা ঋণ. All rights reserved</div>

    <div class="flex-box-list" v-if="msgDlg">
      <div class="msg-box">
        <div class="msg">
          <img src="../assets/title-err.png" class="err-img">
          {{ msg }}
        </div>
        <img src="../assets/close.png" class="close" @click="msgDlg = false">
      </div>
    </div>

  </div>
</template>

<script>
import privacy from "@/components/privacy";
import * as api from "@/api/api";
export default {
  name: 'App',
  components: {
    privacy
  },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      mobile: '',
      password: '',
      code: '',
      msgDlg: false,
      msg: '',
      steps: 1,
      infoData: {},
      Time: 0,
      idcard: '',
      verifyIDCard: '',
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 1: document.getElementById("step_1").scrollIntoView(); break;
        case 2: document.getElementById("step_2").scrollIntoView(); break;
        case 3: document.getElementById("step_3").scrollIntoView(); break;
        case 4: document.getElementById("step_4").scrollIntoView(); break;
        case 5: document.getElementById("step_5").scrollIntoView(); break;
        case 6: document.getElementById("step_6").scrollIntoView(); break;
        case 7: document.getElementById("step_7").scrollIntoView(); break;
        case 8: document.getElementById("step_8").scrollIntoView(); break;
        case 9: document.getElementById("step_9").scrollIntoView(); break;
        case 10: document.getElementById("step_10").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu
    },
    delSearch() {
      let data = {
        mobile: this.mobile,
        password: this.password
      }
      if (!this.mobile) {
        this.msg = 'মোবাইল ফোন নম্বর ফাঁকা হতে পারে না'
        this.msgDlg = true
        return
      }
      if (!this.password) {
        this.msg = 'পাসওয়ার্ড ফাঁকা হতে পারে না'
        this.msgDlg = true
        return
      }

      let loding = this.$loading.show({})
      api.delInfoSearch(data).then(res => {
        loding.hide()
        this.infoData = res.data
        this.steps = 2
      }).catch(e => {
        loding.hide()
        this.msg = e.message
        this.msgDlg = true
      })
    },
    candelete() {
      let data = {
        user_id: this.infoData.user_id
      }
      let loding = this.$loading.show({})
      api.delInfoCanDelete(data).then(res => {
        loding.hide()
        if (res.data.idcard) {
          this.verifyIDCard = res.data.idcard
          this.steps = 5
        } else {
          this.steps = 3
          this.Reenviar()
        }
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    verifyIdCard() {
      console.log(this.verifyIDCard);
      if (this.verifyIDCard == this.idcard) {
        this.steps = 3
        this.Reenviar()
      } else {
        this.msgDlg = true
        this.msg = 'অবৈধ পরিচয়পত্র প্রবেশ করানো হয়েছে এবং যাচাইকরণ ব্যর্থ হয়েছে'
      }
    },
    Reenviar() {
      if (this.Time > 0) {
        return
      }
      this.Countdown(60)
      let data = {
        mobile: this.mobile
      }
      let loding = this.$loading.show({})
      api.delInfoSms(data).then(res => {
        loding.hide()
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    doDelete() {
      if (!this.code) {
        this.msgDlg = true
        this.msg = 'যাচাইকরণ কোড খালি হতে পারে না'
        return
      }
      let loding = this.$loading.show({})
      let data = {
        mobile: this.mobile,
        code: this.code,
        user_id: this.infoData.user_id
      }
      api.delInfoDoDelete(data).then(res => {
        loding.hide()
        this.steps = 4
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    Countdown(time) {
      this.Time = time
      if (time <= 0) {
        return
      }

      setTimeout(() => {
        this.Countdown(time - 1)
      }, 1000);
    }
  }
}
</script>


<style lang="less">
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
